import React from "react";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { CustomSearchTextField } from "../../../../../Components/CustomMuiComponents";
import { ContactosContext } from "../Context/ContactoContext";

export default function SearchContacto({sx = null}) {
  const { filter, setFilter } = React.useContext(ContactosContext);
  
  return (
    <CustomSearchTextField
      placeholder="Buscar"
      size="small"
      variant="outlined"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      sx={sx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
}
